import { authContext, irisRequest } from "utils/authUtils";

const getAccessToken = async (): Promise<string> => {
  if (!authContext) {
    throw new Error(
      "Authorisation context not initialised - is the account area feature flag set?"
    );
  }

  const account = authContext.getActiveAccount();

  if (!account) {
    throw new Error(
      "No active account - verify a user has been signed in and setActiveAccount has been called"
    );
  }

  const response = await authContext.acquireTokenSilent({
    ...irisRequest,
    account,
  });

  return response.accessToken;
};

// We export an object containing the function rather than the function directly.
// This pattern enables reliable stubbing in Cypress tests, as Cypress can stub methods on objects
// but not direct function exports. See: https://github.com/cypress-io/cypress/discussions/16741#discussioncomment-1660404
export default {
  getAccessToken,
};
